<template>
  <div class="container">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/websites' }">概览</el-breadcrumb-item>
        <el-breadcrumb-item>域名管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <template>
      <el-row>
        <el-input v-model="domainsKeywords" placeholder="请输入站点或域名关键字" clearable
          style="width: 300px; margin-right: 10px;" @clear="getDomainsList()"></el-input>
        <el-button type="primary" @click="domainsPage = 1; getDomainsList()" icon="el-icon-search">搜索</el-button>
        <el-button type="primary" @click="registeDomain" icon="el-icon-thumb">注册</el-button>
      </el-row>
      <br>
      <el-table :data="domainsList" border style="width: 100%" height="650" stripe v-loading="domainsLoading">
        <el-table-column prop="domain_name" label="域名" width="300" fixed>
          <template v-slot="scope">
            {{ scope.row.domain_name }}
            <el-link :underline="false">
              <i class="el-icon-copy-document hover-icon" @click="copy(scope.row.domain_name)"></i>
            </el-link>
          </template>
        </el-table-column>
        <el-table-column prop="organization_name" label="注册主体"></el-table-column>
        <el-table-column prop="buy_status" label="购买状态" width="100"></el-table-column>
        <el-table-column prop="dnspod" label="解析" width="100">
          <template v-slot="scope">
            <i class="text-small"
              :class="scope.row.dnspod === true ? 'green el-icon-folder-checked' : 'grey el-icon-folder-delete'">
              <b> {{ scope.row.dnspod === true ? '已托管' : '未托管' }} </b>
            </i>
            <!-- <i class="el-icon-unlock red text-small"> SSL</i> 绿色 红色(要到期) 灰色锁开(已过期)-->
          </template>
        </el-table-column>
        <el-table-column prop="creation_date" label="注册日期" width="160"></el-table-column>
        <el-table-column prop="expiration_date" label="到期日期" width="160">
          <template v-slot="scope">
            <span :class="scope.row.expired_warning ? 'red' : ''">{{ scope.row.expiration_date }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="auto_renew" label="自动续费" width="90">
          <template v-slot="scope">
            <el-switch v-model="scope.row.auto_renew" active-color="#13ce66" inactive-color="#ccc"
              @change="toggleDomainAutoRenew(scope.row, scope.$index)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="creator_name" label="创建人" width="100"></el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template v-slot="scope">
            <el-link type="primary" :underline="false" @click="gotoDnspod(scope.row)" class="text-small"
              v-if="scope.row.dnspod === true">解析</el-link>
            <el-link type="primary" :underline="false" @click="addToDnspod(scope.row)" class="text-small"
              v-else>托管</el-link>
            &nbsp;&nbsp;|&nbsp;&nbsp;
            <el-link type="danger" :underline="false" @click="dissolveDomain(scope.row)"
              class="text-small">注销域名</el-link>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <br>
    <div class="pagenation">
      <el-pagination background layout="total, sizes, prev, pager, next" :total="domainsTotal"
        @size-change="changeDomainsSize" @current-change="currentDomainsChange" :page-sizes="[10, 20, 50, 100]"
        :page-size="domainsSize">
      </el-pagination>
    </div>

    <el-dialog title="注册" :visible.sync="registeDomainVisible" :close-on-click-modal="false">
      <el-form :model="registeDomainForm" label-width="80px" :rules="registeDomainRules" ref="registeDomainForm"
        v-loading="registeDomainLoading" element-loading-text="请稍等">
        <el-row>
          <el-col :span="13">
            <el-form-item label="域名" prop="domain">
              <el-input v-model="registeDomainForm.domain" placeholder="目标域名, 不要带www和后缀"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="5">
            <el-select v-model="registeDomainForm.tld" filterable placeholder="请选择">
              <el-option v-for="item in tencent.tlds" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="4">
            <el-button type="primary" @click="checkDomain">检查</el-button>
          </el-col>
        </el-row>
        <el-row v-if="registeDomainCheckRes.available === false" class="red">
          <el-col :span="24">
            <el-form-item label="">
              <i class="el-icon-error"></i> {{ registeDomainCheckRes.reason }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="registeDomainCheckRes.available === true">
          <el-col :span="24">
            <el-form-item label="">
              <div class="price-line">
                <i class="el-icon-success price-icon"><span class="text-small"> 可注册</span></i>
                <div class="price-box">
                  <span class="origin-price">￥{{ registeDomainCheckRes.price }}</span>
                  <span class="current-price">￥{{ registeDomainCheckRes.real_price }}</span>/首年
                </div>
                <el-checkbox v-model="registeDomainForm.checked" prop="checked"
                  :disabled="registeDomainCheckRes.real_price > tencent.balance"></el-checkbox>
                <span class="balance-text">
                  余额: ￥{{ tencent.balance }}
                  <span class="red" style="margin-left: 20px;"
                    v-if="registeDomainCheckRes.real_price > tencent.balance"><i class="el-icon-error"></i> 余额不足</span>
                </span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="主体" prop="template" v-if="registeDomainForm.checked">
              <el-select v-model="registeDomainForm.template" filterable placeholder="请选择" style="width: 60%;">
                <el-option v-for="item in tencent.templates" :key="item.id" :label="item.organization_name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="支付方式" prop="payment" v-if="registeDomainForm.checked">
              <el-input v-model="registeDomainForm.payment" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="自动续费" prop="auto_renew" v-if="registeDomainForm.checked">
              <el-switch v-model="registeDomainForm.auto_renew" active-color="#13ce66">
              </el-switch>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="registeDomainVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmRegisteDomain">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Nav from '../../Global/Nav.vue'
export default {
  name: 'WebsitesDomains',
  components: {
    Nav
  },
  data() {
    return {
      domainsKeywords: '',
      domainsList: [],
      domainsLoading: true,
      domainsTotal: 0,
      domainsPage: 1,
      domainsSize: 20,
      addDomainVisible: false,
      addDomainLoading: false,
      addDomainForm: {
        domain: ''
      },
      addDomainRules: {
        domain: [
          { required: true, message: '域名不能为空', trigger: 'commit' }
        ]
      },
      tencent: {
        tlds: [],
        balance: 0,
        templates: []
      },
      registeDomainVisible: false,
      registeDomainLoading: false,
      registeDomainForm: {
        domain: '',
        tld: '.com',
        checked: false,
        template: '',
        payment: '余额支付',
        auto_renew: false
      },
      registeDomainRules: {
        domain: [
          { required: true, message: '域名不能为空', trigger: 'commit' }
        ],
        template: [
          { required: true, message: '必须选择注册主体', trigger: 'commit' }
        ]
      },
      registeDomainCheckRes: {
        available: '',
        reason: '',
        price: 0,
        real_price: 0
      }
    }
  },
  mounted() {
    this.getDomainsList();
  },
  methods: {
    copy(text) {
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$message({
        message: '复制成功',
        type: 'success'
      });
    },
    addDomain() {
      this.addDomainVisible = true;
      this.addDomainLoading = false;
      this.addDomainForm = {
        domain: ''
      }
    },
    async confirmAddDomain() {
      await this.$refs.addDomainForm.validate(valid => {
        if (valid) {
          this.addDomainLoading = true;
          this.$axios.post(`/tencent/domains/create`, this.addDomainForm).then((response) => {
            if (response.data.code === 200) {
              setTimeout(() => {
                this.addDomainLoading = false;
                this.addDomainVisible = false;
                this.getDomainsList();
                this.$notify({
                  title: '提示',
                  message: "添加成功",
                  type: 'success'
                });
              }, 10000);
            }
          }).catch(() => {
            this.addDomainLoading = false;
          });
        }
      })
    },
    async getDomainsList() {
      this.domainsLoading = true;
      await this.$axios.get(`/tencent/domains/list`, {
        params: {
          keywords: this.domainsKeywords,
          page: this.domainsPage,
          size: this.domainsSize
        }
      }).then((response) => {
        this.domainsLoading = false;
        if (response.data.code === 200) {
          this.domainsList = response.data.data.data;
          this.domainsTotal = response.data.data.total;
        }
      });
    },
    changeDomainsSize(val) {
      this.domainsSize = val;
      this.getDomainsList();
    },
    currentDomainsChange(val) {
      this.domainsPage = val;
      this.getDomainsList();
    },
    async toggleDomainAutoRenew(row, index) {
      await this.$axios.post(`/tencent/domains/toggle_renew`, {
        id: row.id,
        auto_renew: row.auto_renew
      }).then(() => { }).catch(() => {
        this.domainsList[index].auto_renew = !row.auto_renew;
      });
    },
    async registeDomain() {
      this.registeDomainForm = {
        domain: '',
        tld: '.com',
        checked: false,
        payment: '余额支付',
        auto_renew: false
      }
      this.registeDomainVisible = true;
      this.registeDomainLoading = true;
      await this.$axios.get(`/tencent/domains/tlds`).then((response) => {
        this.registeDomainLoading = false;
        this.tencent.tlds = response.data.data
      })
    },
    async checkDomain() {
      this.registeDomainCheckRes = {
        available: '',
        reason: '',
        price: 0,
        real_price: 0
      }
      this.registeDomainLoading = true;
      await this.$axios.get(`/tencent/billing/balance`).then((response) => {
        this.tencent.balance = response.data.data;
      })
      await this.$axios.get(`/tencent/domains/templates`).then((response) => {
        this.tencent.templates = response.data.data;
      })
      await this.$axios.get(`/tencent/domains/check?domain=${this.registeDomainForm.domain}&tld=${this.registeDomainForm.tld}`).then((response) => {
        this.registeDomainLoading = false;
        this.registeDomainCheckRes = response.data.data;
      })
    },
    confirmRegisteDomain() {
      if (this.registeDomainForm.checked === false) {
        return false;
      }
      this.$refs.registeDomainForm.validate(valid => {
        if (valid) {
          this.$axios.post(`/tencent/domains/create`, this.registeDomainForm).then((response) => {
            if (response.data.code === 200) {
              this.getDomainsList();
              this.$notify({
                title: '操作成功',
                message: '已提交注册',
                type: 'success'
              });
              this.addDomainVisible = false;
              this.addDomainLoading = false;
            }
          }).catch();
        }
      })
    },
    gotoDnspod(row) {
      this.$router.push({
        name: 'websites_dnspod_detail',
        params: {
          domain: row.domain_name
        }
      });
    },
    addToDnspod(row) {
      this.domainsLoading = true;
      this.$axios.post(`/tencent/domains/add_to_dnspod`, {
        domain: row.domain_name
      }).then((response) => {
        setTimeout(() => {
          this.domainsLoading = false;
          this.getDomainsList();
          if (response.data.code === 200) {
            this.$notify({
              title: '操作成功',
              message: row.domain_name + '已成功托管',
              type: 'success'
            });
          }
        }, 5000);
      }).catch();
    },
    dissolveDomain(row) {
      this.$axios.post(`/tencent/dnspod/destroy`, {
        domain: row.domain_name
      }).then().catch();
    }
  }
}
</script>
<style scoped>
.price-line {
  display: flex;
  align-items: center;
}

.price-icon {
  color: #409eff;
  /* ElementUI 主色 */
  margin-right: 8px;
  font-size: 16px;
}

.price-box {
  display: flex;
  align-items: center;
  margin-right: 12px;
}

.origin-price {
  color: #999;
  text-decoration: line-through;
  margin-right: 6px;
}

.current-price {
  color: #f56c6c;
  font-size: 18px;
  font-weight: 600;
}

.balance-text {
  margin-left: 50px;
  font-size: 13px;
  color: #909399;
}
</style>


// WEBPACK FOOTER //
// src/components/Modules/Websites/Domains.vue